
export class Mandanten {

    'Address': 'string' = null;
    'Country': 'string' = 'string';
    'Name': 'string' = null;
    'Street': 'string' = 'string';
    'ZipCode': 'string' = null;
}
